import React, { useEffect, useContext, useState } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Context } from '../../context';
import Timeline from '../core/timeline/timeline';
import './Module.scss';
import { gsap } from 'gsap';

function Module(props) {
  const context = useContext(Context);
  const [current, changeCurrent] = useState('');
  const [redirectLink, setRedirectLink] = useState('');

  useEffect(() => {
    changeCurrent('');
    context.state.linkIndexes ? (
      changeCurrent(props.data.links[context.state.linkIndexes[props.modIndex]])
    ) : (
      <></>
    );
  }, [props.parentRoute, props.modIndex, context.state]);

  return (
    <>
      <div className='module-content-wrap'>
        <Switch>
          {props.data.links.map((link) => {
            return (
              <Route key={link.url} path={link.url}>
                <Timeline
                  nextData={props.nextData}
                  lastData={props.lastData}
                  allLinks={props.data.links}
                  modIndex={props.modIndex}
                  parentRoute={link.url}
                  path={link}
                />
              </Route>
            );
          })}
        </Switch>
        <></>
      </div>
    </>
  );
}

export default Module;
